module.exports = __webpack_public_path__ + "img/KMP.7109a60f.png";